// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7f3566d8","455":"3f36d555","977":"e682c7b2"}[chunkId] + ".chunk.js";
};